import React from 'react';

const filterInputStyle = {
    padding: '8px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    minWidth: '160px',
    width: '100%',
    outline: 'none',
    boxSizing: 'border-box',
};

const filterLabelStyle = { fontSize: '12px', fontWeight: 500, color: '#333' };

/**
 * Busca única (nome vs CPF/CNPJ) igual ao seletor de clientes — mesmo texto de ajuda.
 */
export default function LegalPersonSearchFilter({
    idPrefix = 'legal-person',
    label = 'Buscar',
    placeholder = 'Nome da empresa ou CPF / CNPJ',
    hint = 'Com espaço ou só letras, filtra por nome; CPF/CNPJ (numérico ou alfanumérico, com dígito), por documento. Ordenação: nome (A → Z).',
    hintMinHeight,
    value,
    onChange,
}) {
    const id = `${idPrefix}-search`;
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                width: '100%',
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0 }}>
                <label htmlFor={id} style={filterLabelStyle}>
                    {label}
                </label>
                <input
                    id={id}
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    style={filterInputStyle}
                    autoComplete="off"
                />
            </div>
            {hint ? (
                <p
                    style={{
                        margin: 0,
                        fontSize: '11px',
                        color: '#666',
                        lineHeight: 1.45,
                        minHeight: hintMinHeight,
                    }}
                >
                    {hint}
                </p>
            ) : null}
        </div>
    );
}
